import React from 'react';
import PropTypes from 'prop-types';
import styles from './IconButton.module.scss';

const IconButton = ({visible, disabled, children, clickHandler, icon, containerOverrideClasses}) => {

    if (!visible) {
        return null;
    }

    const containerClasses = [styles.infoIconContainer].concat(containerOverrideClasses);
    if (disabled) containerClasses.push(styles.disabled);

    return (
        <span className={containerClasses.join(' ')} onClick={!disabled ? clickHandler : null}>
            {icon} {children}
        </span>
    );
};

IconButton.propTypes = {
    visible: PropTypes.bool,
    children: PropTypes.any,
    clickHandler: PropTypes.func,
    icon: PropTypes.any,
    containerOverrideClasses: PropTypes.array,
};

IconButton.defaultProps = {
    visible: true,
    children: null,
    clickHandler: () => null,
    icon: <i className='icon-sata-info-icon'/>,
    containerOverrideClasses: [],
};

export default IconButton;